import { Pill } from '@design-system';
import classNames from 'classnames';
import Link from 'next/link';
import { FC, useCallback } from 'react';

import { TrackEvent } from '../../utils/analytics';
import { GlossaryLink } from '../../utils/glossary';

interface Props {
  analytics?: Analytics;
  className?: string;
  glossary: GlossaryLink[];
  onClick?: (term: GlossaryLink) => void;
  title?: string;
  titleIsBold?: boolean;
}

export const GlossaryPills: FC<Props> = ({
  analytics,
  className = '',
  glossary = [],
  onClick,
  title,
  titleIsBold = false,
}) => {
  const handleClick = useCallback(
    (term: GlossaryLink) => {
      onClick?.(term);
      if (analytics) {
        TrackEvent('glossary term click', { ...analytics, term });
      }
    },
    [analytics, onClick],
  );

  if (glossary.length === 0) {
    return null;
  }

  return (
    <section className={classNames('flex flex-col space-y-1', className)}>
      {title && (
        <h2
          className={classNames({
            'text-neutral-4': !titleIsBold,
            'font-bold': titleIsBold,
          })}
        >
          {title}
        </h2>
      )}
      <div className="flex flex-wrap gap-2">
        {glossary.map((term) => (
          <Link
            key={term.full_slug}
            href={`/${term.full_slug}`}
            onClick={() => handleClick(term)}
          >
            <Pill label={term.name} />
          </Link>
        ))}
      </div>
    </section>
  );
};
